import React from "react";
import { Link } from "react-router-dom";
import { BreadcrumbItem, Col, Row, Container, Breadcrumb } from "reactstrap";
import { H3, SVG } from "../../AbstractElements";

interface propsTypes {
  parent: string;
  title: string;
  pageTitle: string;
}

const Breadcrumbs = (props: propsTypes) => {
  const { pageTitle, parent, title } = props;
  return (
    <Container fluid>
      <div className="page-title">
        <Row>
          <Col sm="6" xs="12" className="p-0">
            <H3>{pageTitle}</H3>
          </Col>
          <Col xs="12" sm="6" className="p-0">
            <Breadcrumb>
              <BreadcrumbItem>
                <Link to={`${process.env.PUBLIC_URL}/dashboard/default`}>
                  <SVG iconId="breadcrumb-home" />
                </Link>
              </BreadcrumbItem>
              <BreadcrumbItem>{parent}</BreadcrumbItem>
              <BreadcrumbItem active>{title}</BreadcrumbItem>
            </Breadcrumb>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumbs;
